import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Events from "../scripts/Utils/Events";

/* 
  This class manages the scrolling functionality, including horizontal scrolling of a section, updating a progress bar
*/
class Scroll {
  constructor() {
    this.scrollSection = document.querySelector(".artwork");
    this.progressBar = document.querySelector(".progress");

    this.totalWidth = null;
    this.scrollAmount = null;

    gsap.registerPlugin(ScrollTrigger);

    // Subscribe to content updated event
    Events.subscribe("content.updated", this.init.bind(this));
  }

  init() {
    // Clear any existing ScrollTriggers to avoid duplication
    ScrollTrigger.getAll().forEach((trigger) => trigger.kill());

    const viewportWidth = window.innerWidth;

    // Prevent horizontal scroll on mobile devices
    if (viewportWidth < 769) {
      console.log("Mobile viewport detected. Horizontal scroll disabled.");
      return; // Skip the horizontal scroll setup on mobile
    }

    // Calculate the total width of the scroll section
    this.totalWidth = this.scrollSection.scrollWidth;
    this.scrollAmount = this.totalWidth - viewportWidth;

    // console.log("Total width:", this.totalWidth);

    const self = this; // Reference to the class instance

    // Update GSAP animation with ScrollTrigger
    gsap.to(this.scrollSection, {
      x: -(this.scrollAmount + 32 + 200),
      ease: "none",
      duration: 3,
      scrollTrigger: {
        trigger: this.scrollSection,
        start: "top top",
        end: `+=${this.totalWidth}`,
        scrub: true,
        pin: this.scrollSection,
        anticipatePin: 1,
        onUpdate: function () {
          // Calculate progress manually
          const currentX =
            parseFloat(gsap.getProperty(self.scrollSection, "x")) || 0;
          const totalX = -(self.scrollAmount + 32 + 200);
          const progress = (currentX / totalX) * 100;

          if (self.progressBar) {
            self.progressBar.value = progress;
          }
        },
      },
    });

    // Fade in/out the progress bar when the scrollSection is in view
    gsap.fromTo(
      self.progressBar,
      { opacity: 0 },
      {
        opacity: 1,
        ease: "none",
        scrollTrigger: {
          trigger: self.scrollSection,
          start: "50% bottom", // When the 50% of the scrollSection height reaches the bottom of the viewport
          end: "bottom top", // When the bottom of scrollSection reaches the top of the viewport
          scrub: true,
        },
      }
    );
  }

  onResize() {
    this.init(); // Re-initialize ScrollTrigger on resize
  }
}

export default Scroll;
